import { diffShow } from '../helpers/difftimeline';

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CommentIcon from '@mui/icons-material/Comment';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import DifferenceIcon from '@mui/icons-material/Difference';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

export default function TimelineComponent(props: any) {
  const { get_log } = props;

  // Function to get icon based on type
  function get_icon(type: string) {
    if (type === 'created') {
      return <AccessTimeIcon />;
    }

    if (type === 'comment') {
      return <CommentIcon />;
    }

    if (type === 'status') {
      return <DoubleArrowIcon />;
    }

    if (type === 'rider') {
      return <DirectionsBikeIcon />;
    }

    if (type === 'diff') {
      return <DifferenceIcon />;
    }

    return <TimelineDot />;
  }

  return (
    <Timeline>
      {diffShow(get_log).map((timelinediff: any, index: number) => {
        return (
          <TimelineItem key={timelinediff.id}>
            <TimelineOppositeContent color="text.secondary">
              <pre>{timelinediff.timeline}</pre>
            </TimelineOppositeContent>
            <TimelineSeparator>
              {get_icon(timelinediff.type)}
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ width: '100px' }}>
              {timelinediff.type === 'diff' ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ padding: '0' }}>
                        <b>Field Name</b>
                      </TableCell>
                      <TableCell style={{ padding: '0' }}>
                        <b>Old</b>
                      </TableCell>
                      <TableCell style={{ padding: '0' }}>
                        <b>New</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {timelinediff.logs.map((item: any) => {
                      return (
                        <TableRow>
                          <TableCell style={{ padding: '0' }}>{item[0]}</TableCell>
                          <TableCell style={{ padding: '0' }}>{item[2]}</TableCell>
                          <TableCell style={{ padding: '0' }}>{item[1]}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              ) : (
                timelinediff.details ?? ''
              )}
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
}
